import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  HostListener,
} from "@angular/core";
import { Standard } from "../models/standard";
import { FilteringGuide } from "../models/filteringGuide";
import { StandardService } from "../services/standard.service";
import { Router, ActivatedRoute } from "@angular/router";
import { StandardList } from "../models/standard-list";
import {
  StandardListType,
  UserRoleUserOperation,
  StandardTypeEnum,
  Constant,
  UserRoleEnum,
} from "../core/constant";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { environment } from "../../environments/environment";
import { CryptographyService } from "../services/cryptography.service";
import { NgbModalOptions, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EquipmentStandard } from "../models/equipment-standard";
import { EquipmentStandardService } from "../services/equipment -standard.service";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { MatMenuTrigger } from "@angular/material/menu";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { FilterList } from "../models/filterList";
import { Sort } from "@angular/material/sort";
import { CustomEventNRService } from "../services/custom-event-nr.service";
import { Country } from "../models/country";
import * as XLSX from "xlsx";

@Component({
  selector: "app-view-all-obsolete-standard-list",
  templateUrl: "./view-all-obsolete-standard-list.component.html",
  styleUrls: ["./view-all-obsolete-standard-list.component.scss"],
})
export class ViewAllObsoleteStandardListComponent implements OnInit {
  selectedStandardsForExport = new Map<number, Standard>();
  exportSelectedIds: any[] = [];
  countries: Country[] = [];
  activePopupId: any;
  totalPages: any;
  selectedCountryId: number = 0;

  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;
  pageSizes: any[] = Constant.PageSizes;
  searchKey: string = "";
  loading: boolean = false;
  standards: Standard[] = [];
  error: string = "";

  filterList: FilteringGuide[] = [];
  canEditEquipmentStandard: boolean;
  canDeleteEquipmentStandard: boolean;
  modalOption: NgbModalOptions = {};
  equipmentStandard: EquipmentStandard = new EquipmentStandard();
  get standardListType() {
    return StandardListType;
  }
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  standardFiltrationForChipSet: FilterList = new FilterList();

  constructor(
    private standardService: StandardService,
    private cryptographyService: CryptographyService,
    private router: Router,
    @Inject(LOCAL_STORAGE) public storage: WebStorageService,
    private activatedRoute: ActivatedRoute,
    private ngbModal: NgbModal,
    private equipmentStandardService: EquipmentStandardService,
    private customEventNRService: CustomEventNRService,
  ) {}

  ngOnInit() {
    this.standardFiltrationForChipSet.standardListType =
      StandardListType.Obsolete;
    this.setUserPrivilages();
    this.loadCountries();
    this.filterList = this.standardService.obsoleteStandardFiltration.filterSet;
    this.pageSize = this.standardService.obsoleteStandardFiltration.pageSize;
    this.searchKey = this.standardService.obsoleteStandardFiltration.searchKey;
    this.page = this.standardService.obsoleteStandardFiltration.startingIndex || 1;
    this.getAllEquipmentStandards();
  }

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  isGlobalAdmin(): boolean {
    return this.getEffectiveUserRole() === UserRoleEnum.GlobalAdmin;
  }

  loadCountries() {
    const userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole"),
    );
    const userId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );
    this.standardService
      .GetMasterDataForAddNrbes(userRole, userId)
      .subscribe((data: any) => {
        this.countries = data.countries || [];
        if (
          userRole === UserRoleEnum.MarketAdmin ||
          userRole === UserRoleEnum.BasicUser
        ) {
          const countryIds = this.cryptographyService.decryptData(
            this.storage.get("countryId"),
          );
          this.countries = this.countries.filter((x) =>
            countryIds.includes(x.id),
          );
        }
      });
  }

  receivedFilteration($event) {
    this.page = 1;
    this.filterList = $event;
    this.standardService.obsoleteStandardFiltration.filterSet = this.filterList;
    this.getAllEquipmentStandards();
  }

  onCountryfromChild(event: any) {
    this.page = 1;
    this.selectedCountryId = event?.id ?? 0;
    this.getAllEquipmentStandards();
  }
  setUserPrivilages() {
    if (!environment.skipAuthentication) {
      let userRoleUserOperation = this.storage.get("userRoleUserOperation")
        ? this.cryptographyService.decryptData(
            this.storage.get("userRoleUserOperation"),
          )
        : this.storage.get("userRoleUserOperation");
      if (userRoleUserOperation) {
        this.canEditEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanEditEquipmentStandard,
          ) !== -1;
        this.canDeleteEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanDeleteEquipmentStandard,
          ) !== -1;
      }
    } else {
      this.canEditEquipmentStandard = true;
      this.canDeleteEquipmentStandard = true;
    }
  }

  //compare
  compare(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean,
  ) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction === "" || !(this.standards.length > 0)) {
      return;
    }
    void 0;

    const isAsc = sort.direction === "asc";
    this.standards.sort((a, b) => {
      switch (sort.active) {
        case "title":
          return this.compare(a.title, b.title, isAsc);
        case "model":
          return this.compare(
            a.equipmentStandard.model,
            b.equipmentStandard.model,
            isAsc,
          );
        case "equipment":
          return this.compare(
            a.equipmentStandard.equipmentType.name,
            b.equipmentStandard.equipmentType.name,
            isAsc,
          );
      }
    });
  }
  getAllEquipmentStandards() {
    this.loading = true;
    this.standardService.obsoleteStandardFiltration.pageSize = this.pageSize;
    this.standardService.obsoleteStandardFiltration.startingIndex = this.page;
    this.standardService
      .getAllStandards(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        StandardListType.Obsolete,
        this.filterList,
        null,
        this.searchKey,
        null,
      )
      .subscribe((data: StandardList) => {
        void 0;

        // this.standards = [];
        if (data.standardDetailList != null)
          this.standards = data.standardDetailList.map((o) => new Standard(o));

        void 0;
        this.collectionSize = data.count;
        this.totalPages = Math.ceil(this.collectionSize / this.pageSize);

        if (this.filterList.length > 0) {
          this.customEventNRService.sendFilterEvent(
            "Grsallfilters",
            JSON.stringify(this.filterList),
            this.standards.length,
          );
        }
        this.loading = false;
        (error: string) => {
          this.error = error;

          this.loading = false;
        };
      });
  }

  onEdit(id, event) {
    event.stopPropagation();
    this.standardService.standardEditPreviousRoute =
      this.activatedRoute.snapshot.routeConfig.path;
    this.router.navigate(["/edit-eq-standards-global", id]);
  }

  openDeletePopup(item, event) {
    event.stopPropagation();
    this.modalOption.backdrop = "static";
    this.modalOption.keyboard = false;
    this.equipmentStandard.id = item.equipmentStandard.id;
    const modalRef = this.ngbModal.open(
      DeleteDialogComponent,
      this.modalOption,
    );
    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    if (
      item.standardTypeId == StandardTypeEnum.GlobalMinimumRestaurantStandard ||
      item.standardTypeId == StandardTypeEnum.GlobalEquipmentStandard
    ) {
      modalRef.componentInstance.message =
        "All the dependencies will be removed along with this standard";
    }
    modalRef.componentInstance.deleteItem = item.id;
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItemId) => {
      if (deleteItemId != null) {
        let equipmentStandard = new EquipmentStandard();
        equipmentStandard.id = deleteItemId;
        equipmentStandard.isDeleted = true;
        this.loading = true;
        this.equipmentStandardService
          .deleteEquipmentStandard(equipmentStandard)
          .subscribe((data: any) => {
            this.loading = false;
            this.page = 1;
            this.getAllEquipmentStandards();
          });
      }
      this.ngbModal.dismissAll();
    });
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    this.trigger.closeMenu();
    setTimeout(() => {
      this.openDeletePopup(item, event);
    }, 100);
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.standardService.obsoleteStandardFiltration.pageSize = this.pageSize;
    this.getAllEquipmentStandards();
  }

  addSearchKey(searchKey) {
    this.searchKey = searchKey;
    this.page = 1;
    this.standardService.obsoleteStandardFiltration.searchKey = this.searchKey;
    this.getAllEquipmentStandards();
  }

  rowSelected(item: any): void {
    this.standardService.fromLocationGRS = false;
    const id = item?.id || item?.standardId || item?.standard?.id;
    if (id) {
      this.router.navigate([
        "/view-obsolete-equipments-standard-detail/" + id,
      ]);
    }
  }

  downloadExcel(
    exportFilterList: FilteringGuide[] = null,
    exportCountryIds: any[] = [],
  ) {
    const filters = exportFilterList ?? this.filterList;
    const countryId =
      exportCountryIds?.length > 0 ? exportCountryIds : null;
    this.standardService
      .downloadExcel(
        0,
        this.collectionSize,
        StandardListType.Obsolete,
        filters,
        countryId,
        this.searchKey,
      )
      .subscribe(
        (response: any) => {
          let filename =
            "Obsolete_Standard_List " + new Date().toLocaleString();
          this.standardService.saveExportBlob(response, filename);

          //window.open(url);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        },
      );
  }
  getLocationNames(item): any {
    if (item.standardLocation && item.standardLocation.length > 0) {
      return item.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    } else {
      return item.locationType.name;
    }
  }

  goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.getAllEquipmentStandards();
    }
  }

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      this.getAllEquipmentStandards();
    }
  }

  togglePopup(event: MouseEvent, item: any): void {
    event.stopPropagation();
    // Close if clicking the same row, otherwise open new one
    this.activePopupId = this.activePopupId === item.id ? null : item.id;
  }
  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest(".grid-actions")) {
      this.activePopupId = null;
    }
  }

  onCheckboxChange(event: any, item: Standard) {
    if (event.checked) {
      this.selectedStandardsForExport.set(item.id, item);
    } else {
      this.selectedStandardsForExport.delete(item.id);
    }
  }

  isSelected(id: number): boolean {
    return this.selectedStandardsForExport.has(id);
  }

  getSelectableRowsOnPage(): Standard[] {
    return this.standards || [];
  }

  isAllOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    return selectable.every((item) => this.isSelected(item.id));
  }

  isSomeOnPageSelected(): boolean {
    const selectable = this.getSelectableRowsOnPage();
    if (selectable.length === 0) {
      return false;
    }
    const selectedCount = selectable.filter((item) =>
      this.isSelected(item.id),
    ).length;
    return selectedCount > 0 && selectedCount < selectable.length;
  }

  selectAllOnPageChange(event: any): void {
    const selectable = this.getSelectableRowsOnPage();
    if (event.checked) {
      selectable.forEach((item) => {
        this.selectedStandardsForExport.set(item.id, item);
      });
    } else {
      selectable.forEach((item) => {
        this.selectedStandardsForExport.delete(item.id);
      });
    }
  }

  onSearchFromChild(searchValue: string) {
    this.addSearchKey(searchValue);
  }

  handleExport(exportFilterList?: FilteringGuide[]) {
    if (this.selectedStandardsForExport.size > 0) {
      this.exportSelected();
      return;
    }
    this.downloadExcel(exportFilterList, this.exportSelectedIds);
  }

  handleCountryList(countryList: any) {
    this.exportSelectedIds = countryList;
  }

  exportSelected() {
    const selectedData = Array.from(this.selectedStandardsForExport.values());
    if (selectedData.length === 0) {
      const modalRef = this.ngbModal.open(FailModuleComponent);
      modalRef.componentInstance.errorMessage =
        "No selected standards to export.";
      return;
    }

    const formattedData = selectedData.map((item) => ({
      "Standard ID": item.id,
      Title: item.title,
      Model: item.equipmentStandard?.model || "",
      "Equipment Type": item.equipmentStandard?.equipmentType?.name || "",
      Location: this.getLocationNames(item),
      "Approved Date": item.effectiveFrom
        ? new Date(item.effectiveFrom).toLocaleDateString("en-US")
        : "",
      "Obsolete Date": item.equipmentStandard?.obsoleteDate
        ? new Date(item.equipmentStandard.obsoleteDate).toLocaleDateString(
            "en-US",
          )
        : "",
    }));

    const fileName =
      "Obsolete_Standard_List " + new Date().toLocaleString() + ".xlsx";
    this.selectedDownloadExcel(formattedData, fileName);
  }

  selectedDownloadExcel(data: any[], fileName: string) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Standards");
    this.standardService.saveXlsxWorkbook(workbook, fileName);
  }
}
